package ru.villawonka.app.data.source

import io.ktor.client.HttpClient
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import ru.villawonka.app.data.entity.request.TelegramAuthRequest
import ru.villawonka.app.data.entity.response.AuthResponse
import ru.villawonka.app.data.utils.parseResponse
import ru.villawonka.app.AppConfig

class AuthApi {
    private val client = HttpClient {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
            })
        }
        defaultRequest {
            contentType(ContentType.Application.Json)
        }
    }

    suspend fun authByTelegram(request: TelegramAuthRequest): AuthResponse = parseResponse {
        client.post(AppConfig.apiUrl + "/auth/telegram") { setBody(request) }
    }
}